import { Group } from '@visx/group';

import { VisxText } from '@/components/VisxText';

import { useTheme } from 'styled-components';

interface Props {
  top?: number;
  left?: number;
  children: string;
}

export const Label = ({ top = 0, left = 0, children }: Props) => {
  const theme = useTheme();
  return (
    <Group top={top} left={left}>
      <VisxText
        typography="tiny"
        verticalAnchor="start"
        textAnchor="start"
        fill={theme.color.whiteRGBA(0.5)}
      >
        {children}
      </VisxText>
    </Group>
  );
};
